import { Section } from 'components/Shared/Layout';
import { ColumnLayout } from 'components/Shared/Layout/columnLayout';
import styles from './styles.scss';
import { IconPhone, IconCheckmark } from 'components/Shared/Icon';
import connect from 'components/Shared/connect';
import { SectionPageModel } from 'models/SectionPageModel';
import { rm } from 'utils';
import Categories, { Category, mapToCategories } from 'components/Categories';
import { IMenuItem } from 'models/IMenuItem';

interface MergedProps {
  numberOfColumns: number;
  header: string;
  shortDescription: string;
  usps: string[];
  openingHours: string;
  sectionCategories: Category[];
}

const NUMBER_OF_CATEGORY_LINKS = 8;

const SectionDescription = ({
  header,
  shortDescription,
  usps,
  openingHours,
  sectionCategories
}: MergedProps) => (
  <Section appearance="secondary">
    <Categories
      categories={sectionCategories}
      showAllCategoriesText={rm('navigation_seeallcountcategories')}
    />
    <Section appearance="secondary" className={styles.sectionDescription}>
      <h1>{header}</h1>
      <ColumnLayout gutters>
        {shortDescription && (
          <div>
            <p>{shortDescription}</p>
          </div>
        )}
        <div className={styles.usps}>
          {usps && (
            <ul>
              {usps.map(usp => (
                <li key={usp}>
                  <IconCheckmark size="small" />
                  {usp}
                </li>
              ))}
            </ul>
          )}
        </div>
        <div>
          <h3>{rm('general_info_helpheader')}</h3>
          <p>{rm('general_info_helpbody_time', openingHours)}</p>
          <a href={`tel:${rm('general_customercontactnumber')}`}>
            <IconPhone size="small" />
            {rm('shared_footer_customerservice_call')}&nbsp;
            {rm('shared_footer_customerservice_callnumber')}
          </a>
        </div>
      </ColumnLayout>
    </Section>
  </Section>
);

interface StateProps {
  categories: IMenuItem[];
}
export default connect<MergedProps, Record<string, unknown>, StateProps>(
  ({ currentPage }) => ({
    header: (currentPage as SectionPageModel).header,
    shortDescription: (currentPage as SectionPageModel).shortDescription,
    usps: (currentPage as SectionPageModel).usps,
    categories: (currentPage as SectionPageModel).sectionCategories,
    openingHours: (currentPage as SectionPageModel).openingHours
  }),
  undefined,
  ({ categories, ...state }, dispatch, own) => ({
    ...state,
    ...dispatch,
    ...own,
    sectionCategories: mapToCategories(NUMBER_OF_CATEGORY_LINKS, categories)
  })
)(SectionDescription);
